import React from 'react'

class Introduction extends React.Component {
  render() {
    return (
      <center>
        <h3 className="title is-3">
          We are passionate about gaming, Ethereum, and the future of global finance.
        </h3>
        <p>
          Since its founding in early 2018, BurzNest has been hell-bent on developing the most cutting edge games on top of the Ethereum platform. We believe that the Ethereum platform is the natural path for any game with a natural marketplace as well as for the new phenomenon of "micropayment" gaming.
        </p>
        <p>
          We aim to be <i>the</i> name in Ethereum gaming.
        </p>
      </center>
    )
  }
}

export default Introduction



// WEBPACK FOOTER //
// ./src/Introduction.js